// $(document).ready(function() {  
  
//     $(".close_overlay").on('click', function(){
//       $(".body_overlay").fadeOut();
//     });
// });

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".close_overlay").forEach(function (el) {
    el.addEventListener("click", function () {
      document.querySelectorAll(".body_overlay").forEach(function (overlay) {
        overlay.style.transition = "opacity 0.4s";
        overlay.style.opacity = "0";

        setTimeout(function () {
          overlay.style.display = "none";
        }, 400);
      });
    });
  });
});